// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"Header_MainContent__z6FUL","MainContentImage":"Header_MainContentImage__3DEr4"};